import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { SalesOrderFilterInput } from '@/graphql/contracts/_generated_/contracts';
import { GetPaginatedFilteredSalesOrders, GetPaginatedFilteredSalesOrdersVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredSalesOrders.query';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';
import GetPaginatedFilteredSalesOrdersQuery from '@/graphql/contracts/getPaginatedFilteredSalesOrders.query.gql';

export type PaginatedFilteredSalesOrders = PaginatedFilteredGridData<SalesOrderFilterInput>;

export default function useGetSalesOrders() {
  const [_getSalesOrders] = useLazyQuery<
  GetPaginatedFilteredSalesOrders,
  GetPaginatedFilteredSalesOrdersVariables
  >(GetPaginatedFilteredSalesOrdersQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getSalesOrders = async (params: PaginatedFilteredSalesOrders) => {
    const response = await _getSalesOrders({
      variables: {
        ...params,
      } as GetPaginatedFilteredSalesOrdersVariables,
    });

    return response?.data?.paginatedFilteredSalesOrders;
  };

  return { getSalesOrders };
}
